'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = (0, _reactackleCore.withExternalProps)(_reactackleCore.CARD_CHANNEL);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-card/dist/withExternalPropsCard.js
// module id = 37
// module chunks = 0